export enum ValveRelay {
  ON = 1,
  OFF = 0
}
